import { AreaChart, Area, YAxis, ResponsiveContainer } from "recharts";
import { money, signedMoney, pnlColor, pct } from "../lib/format";

export const AccountPanel = ({ account, equitySeries }) => {
  const acc = account || {};
  const up = (acc.equity || 0) >= (acc.starting_balance || 0);
  const color = up ? "#22c55e" : "#ef4444";

  const Cell = ({ label, value, cls }) => (
    <div className="px-2 py-1.5 border-r border-b border-zinc-800/70">
      <div className="text-[9px] uppercase tracking-wide text-zinc-500">{label}</div>
      <div className={`font-mono text-[12px] font-semibold ${cls || "text-zinc-100"}`}>{value}</div>
    </div>
  );

  return (
    <div className="flex flex-col">
      <div className="h-16 px-1 pt-1">
        <ResponsiveContainer width="100%" height="100%" minWidth={1} minHeight={40}>
          <AreaChart data={equitySeries} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient id="eq" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={color} stopOpacity={0.35} />
                <stop offset="100%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>
            <YAxis domain={["dataMin", "dataMax"]} hide />
            <Area type="monotone" dataKey="equity" stroke={color} strokeWidth={1.4} fill="url(#eq)" isAnimationActive={false} dot={false} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-2 border-t border-zinc-800">
        <Cell label="Equity" value={money(acc.equity)} />
        <Cell label="Balance" value={money(acc.balance)} />
        <Cell label="Realized P&L" value={signedMoney(acc.realized_pnl)} cls={pnlColor(acc.realized_pnl)} />
        <Cell label="Unrealized" value={signedMoney(acc.unrealized_pnl)} cls={pnlColor(acc.unrealized_pnl)} />
        <Cell label="Daily P&L" value={signedMoney(acc.daily_pnl)} cls={pnlColor(acc.daily_pnl)} />
        <Cell label="Max Drawdown" value={pct(-(acc.max_drawdown || 0))} cls="text-red-400" />
        <Cell label="Trades" value={acc.trades_count ?? 0} />
        <Cell label="Win Rate" value={`${acc.winrate ?? 0}% (${acc.wins || 0}/${acc.losses || 0})`} cls={up ? "text-green-500" : "text-zinc-100"} />
      </div>
    </div>
  );
};
